/**
 * Browser navigation that leaves the current app instance behind.
 */
export const navigation = {
  /**
   * Seam over `window.location.assign`, so tests can observe a navigation
   * without unloading the test frame.
   *
   * @param url Absolute or root-relative URL to load.
   */
  navigateTo(url: string): void {
    window.location.assign(url);
  },

  /**
   * Performs a full page load, discarding every piece of in-memory application
   * state.
   *
   * Use this at the identity boundary. An SPA transition keeps the WarpDrive
   * store, service singletons, in-flight requests, and module-level caches
   * alive across a logout, so whatever the teardown left half-finished is still
   * there for the next login in that tab to trip over.
   *
   * @param url Absolute or root-relative URL to load.
   */
  hardNavigate(url: string): void {
    navigation.navigateTo(url);
  },
};
